import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=20dcc4c2&scoped=true&"
var script = {}
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=20dcc4c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dcc4c2",
  null
  
)

export default component.exports